/**
 * @fileOverview This file contains the implementation of the location add modal for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Diego Benitez Reyna
 */

import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import Modal from 'react-bootstrap/Modal';
import 'react-toastify/dist/ReactToastify.css';

import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';
import { trimValue } from '../../../utils/generalUtils';

const ModalAddLocation = ({ show, onHide, refreshData }) => {
  const [rack, setRack] = useState('');
  const [inventoryTypeId, setInventoryTypeId] = useState('');

  const [inventoryTypeList, setInventoryTypeList] = useState([]);

  const { newStr, saveStr } = useTranslationHook();

  const handleClose = () => {
    resetFields();
    refreshData();
    onHide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimedRack = trimValue(rack);

    try {
      const createRes = await customAxios.post(
        `${GlobalVariables.getURL()}locations/create`,
        {
          rack: trimedRack,
          inventory_type_id: inventoryTypeId,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );

      getToast({
        status: createRes.data.status,
        title: createRes.data.message,
      });

      handleClose();
    } catch (error) {
      console.log(error);
      if (error.response.data?.errors) {
        const errors = error.response.data?.errors;
        errors.forEach((err) => {
          getToast({ status: 'error', title: err.message });
        });
      } else {
        getToast({
          status: error.response.data.status,
          title: error.response.data.message,
        });
      }
    }
  };

  const resetFields = () => {
    setRack('');
    setInventoryTypeId('');
  };

  const getInventoryTypeList = async () => {
    try {
      const { data: res } = await customAxios.get(
        `${GlobalVariables.getURL()}inventory/getInventoryTypesList`,
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        }
      );
      setInventoryTypeList(res.data);
    } catch (error) {
      console.log(error);
      setInventoryTypeList([]);
    }
  };

  useEffect(() => {
    if (!show) return;

    getInventoryTypeList();
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      backdropClassName='modal-backdrop'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {`${newStr} Ubicación`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='inventory-form' onSubmit={handleSubmit}>
          <div className='row'>
            <div className='col-md-12'>
              <TextField
                sx={{ width: '100%' }}
                label='Nombre'
                type='text'
                value={rack}
                onChange={(e) => setRack(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className='row'>
            <div className='col-md-12'>
              <Autocomplete
                disablePortal
                includeInputInList={false}
                options={inventoryTypeList}
                sx={{ width: '100%' }}
                getOptionLabel={(inventoryTypeList) => inventoryTypeList.name}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='Seleccionar almacén...'
                    inputProps={{
                      ...params.inputProps,
                    }}
                    required={true}
                  />
                )}
                onChange={async (e, value) => {
                  setInventoryTypeId(value.id);
                }}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type='submit'
          form='inventory-form'
          className='save-modal-button'
        >
          {saveStr}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddLocation;
